import { render, staticRenderFns } from "./BulkFeedback.vue?vue&type=template&id=832e3c88&"
import script from "./BulkFeedback.vue?vue&type=script&lang=ts&"
export * from "./BulkFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./BulkFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports